import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-93864a42")
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "total-caption heading" }, "Month", -1)
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-hover" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Position"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Property"),
    /*#__PURE__*/_createElementVNode("th", null, "# Sold phone plans"),
    /*#__PURE__*/_createElementVNode("th", null, "# Sold AKKO plans")
  ])
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LastTwelveMonthsSelector = _resolveComponent("LastTwelveMonthsSelector")!
  const _component_TeamRow = _resolveComponent("TeamRow")!
  const _component_AkkoCard = _resolveComponent("AkkoCard")!

  return (_openBlock(), _createBlock(_component_AkkoCard, null, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_LastTwelveMonthsSelector, {
          includeCurrentMonth: true,
          "css-classes": "month-selector form-control",
          onChangeSelection: _cache[0] || (_cache[0] = (event) => _ctx.handleChangeOnMonthSelection(event))
        })
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesRepresentatives, (user) => {
              return (_openBlock(), _createBlock(_component_TeamRow, {
                key: user,
                user: user
              }, null, 8, ["user"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}